import { PartState } from '../types';

export const disappointedState: PartState = {
	antenna1: {
		path: 'M187.5 72.9255C196.656 73.5995 215.989 79.4336 220.078 97.3779',
		tip: { cx: 220.279, cy: 98.3578, r: 4.5 },
	},
	antenna2: {
		path: 'M113.885 72.9003C104.711 73.2351 85.1746 78.3499 80.4244 96.1307',
		tip: { cx: 80.54, cy: 95.65, r: 4.5 },
	},
	body: { x: 103, y: 62, width: 100, height: 162, rx: 32 },
	bodyHighlight:
		'M184 79C172.649 65.0899 142.137 61.3331 132 61C211.534 61 207.635 61 213.873 138.954C218.531 197.168 196.756 220.66 188.13 222.445C187.194 222.638 186.495 221.842 186.495 220.886C186.504 178.976 196.493 94.3093 184 79Z',
	stripes: { y1: 140, y2: 169, y3: 198, height: 15 },
	eyes: { y: 96.5, leftX: 113.435, rightX: 151.966, width: 10.4139, height: 16.6623, rx: 5.20697 },
	wing1Path:
		'M216.878 107.7L172.214 116.629C169.565 117.159 167.124 118.436 165.179 120.31C159.557 125.726 159.39 134.673 164.806 140.295L166.587 142.144C168.279 143.9 170.334 145.264 172.609 146.141L206.22 159.094C208.403 159.935 210.678 160.519 212.997 160.831L220.013 161.778C229.49 163.057 238.939 159.242 244.872 151.743C254.498 139.576 251.954 121.825 239.299 112.851L238.538 112.311C232.26 107.859 224.425 106.191 216.878 107.7Z',
	wing2Path:
		'M227.16 142.716L181.983 136.919C179.304 136.575 176.582 137.006 174.14 138.161C167.084 141.498 164.069 149.924 167.407 156.981L168.505 159.302C169.547 161.506 171.059 163.455 172.935 165.012L200.652 188.017C202.452 189.512 204.422 190.791 206.519 191.828L212.867 194.965C221.439 199.202 231.611 198.604 239.628 193.391C252.634 184.934 255.891 167.3 246.763 154.755L246.214 154.001C241.686 147.778 234.794 143.696 227.16 142.716Z',
	arms: [
		{ d: 'M99.7471 181.759L104.068 150.948', side: 'left' },
		{ d: 'M203.261 150.672L209.919 181.065', side: 'right' },
	],
	stinger:
		'M141.396 244.845C143.661 242.13 145.665 237.522 147.164 233.138C148.366 229.623 152.476 227.863 155.693 229.72C158.353 231.255 159.267 234.7 157.082 236.858C152.801 241.086 146.798 244.015 142.002 245.732C140.964 246.103 140.689 245.691 141.396 244.845Z',
};
